import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { restServices } from 'src/app/rest.service';
import { LiveRates } from '../../models/entities/live-rates';

@Injectable()
export class CambiService {

  resourceUrlCambi = environment.api_rischiocambio_url + restServices.cambi;
  resourceUrlSpotByCross = environment.api_rischiocambio_url + restServices.getSpotByCross;

  constructor(private http: HttpClient) { }

  public getCambi(): Observable<Array<LiveRates>> {
    return this.http.get<Array<LiveRates>>(`${this.resourceUrlCambi}`);
  }

  public getSpotByCross(cross: string): Observable<any> {
    return this.http.get<any>(`${this.resourceUrlSpotByCross}/${cross}`, { observe: 'response' });
  }

}